import { render, staticRenderFns } from "./StripeBankAccount.vue?vue&type=template&id=529fb50a&scoped=true"
import script from "./StripeBankAccount.vue?vue&type=script&lang=js"
export * from "./StripeBankAccount.vue?vue&type=script&lang=js"
import style0 from "./StripeBankAccount.vue?vue&type=style&index=0&id=529fb50a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529fb50a",
  null
  
)

export default component.exports